import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useShop } from '@/hooks/useShop';

/**
 * ShopInitializer keeps the shop list in sync with auth state.
 * Initial bootstrapping is handled in ShopProvider.
 */
export function ShopInitializer() {
  const { loadShops } = useShop();

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      const userId = session?.user?.id;
      if (!userId) return;
      // Re-load shops when user signs in / token refreshes
      void loadShops(userId);
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [loadShops]);

  return null;
}

